<template>
    <div id="top_wrap" :class="{ show, notransition }">
        <div id="sketch_container" ></div>
        <div class="title-banner">
            <h1 class="name">Brandon Aguirre</h1>
            <div class="light">
                <p>FREELANCE</p>
                <div class="titles"> 
                    <scroll-display :titles="titles.map((title) => title.toUpperCase())" initial-delay="2000" display-delay="3000"/>
                </div>
                <p><img style="width:20px; height:20px; margin: 0 0 -3px 5px;" :src="getImageUrl('map_pin.svg')"> BOULDER, CO</p>
                <div style="margin-top: 50px;">
                    <button class="butt outline banner-butt" @click="$emit('scroll-flip')">Contact Me</button>
                    <!-- <button class="butt outline banner-butt">Hire Me</button> -->
                </div>
            </div>
        </div>
        <div id="home_page_top_bottom_banner">
            <div id="weather_banner"><p>{{weatherDisplay}}&#8457;</p></div>
        </div>
    </div>
</template>

<script>
    import p5 from 'p5'
    import MountainSketch from '@/js/HomeSketch/MountainSketch'
    import mountainData from '@/data/BezierSketch'
    import axios from 'axios'
    import weatherData from '@/data/DummyWeatherData'
    import ScrollDisplay from '@/components/ScrollDisplay'

    export default {
        name: "SketchBackground",
        emits: ['scroll-flip'],
        components: {
            ScrollDisplay
        },
        data () {
            return {
                titles: ['software engineer', 'full stack web developer', 'machine learning engineer'],
                sketch: null,
                show: false,
                notransition: false,
                weatherResponse: null,
            } 
        },
        computed: {
            weatherDisplay () {
                if (this.weatherResponse === null) {
                    return null
                }
                const temp = this.weatherResponse.main.temp
                const weather = this.weatherResponse.weather[0]

                const description = weather ? weather.main : ''
                return description + ', ' + Math.round(temp)
            }
        },
        methods: {
            fetchWeather () {
                const params = new URLSearchParams()
                params.append('q', 'Boulder,Colorado')
                params.append('appid', '49020771323ce1c8ceadd4f09d76e231')
                params.append('units', 'imperial')
                const url = 'https://api.openweathermap.org/data/2.5/weather'

                return axios(url, {
                    method: 'GET',
                    params
                })
                    .then((response) => {
                        this.weatherResponse = response.data
                    })
            },
        },
        mounted () {
            if (process.env.NODE_ENV === 'production') {
                this.fetchWeather()
            } else {
                this.weatherResponse = weatherData
            }
            this.sketch = new MountainSketch(mountainData(), true)
            this.p5sketch = new p5(this.sketch.sketch.bind(this.sketch), 'sketch_container')
            const sketch_container = document.getElementById('sketch_container')
            // NOTE: Below works, however there is a bug w/ p5 sketch creating more than one default canvas
            if (sketch_container.children.length > 1) {
                sketch_container.removeChild(sketch_container.children[0])
            }
            window.__sketch_page_visited = window.__sketch_page_visited ? window.__sketch_page_visited + 1 : 1
            if (window.__sketch_page_visited > 1) {
                this.notransition = true
                this.show = true
            }
            setTimeout(() => {
                this.show = true
            }, 100);
        },
        unmounted () {
            this.sketch.destroy()
        }
    }
</script>

<style scoped lang="scss">

    #top_wrap {
        opacity: 0;
        transition: opacity 2s linear;

        &.show {
            opacity: 1;
        }

        &.notransition {
            transition: none;
        }
    }

    #sketch_container {
        position: absolute;
        z-index: -9999;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background: white;
    }

        #home_page_top_bottom_banner {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 50px;
        width: 100%;
        color: white;

        #weather_banner {
        position: absolute;
        bottom: 0;
        left: 0;
            p {
                padding: 0 20px;
                // margin-bottom: 0;
            }
        }

    }
    

    .title-banner {
        text-align: center;
        width: 100%;
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -40%);
    }

    .name {
        font-size: max(6vw, 3rem);
        font-family: 'Pacifico', cursive;
        margin-top: 0;
    }

    .titles {
        font-size: max(2.5vw, 1.5rem);
    }

    .light {
        font-weight: 300;
        > p {
            font-size: max(1.5vw, 0.9rem);
            &:nth-of-type(1) {
                margin-bottom: 0;
            }
            &:nth-of-type(2) {
                margin-top: 0;
            }
        }
    }

    .butt.outline.banner-butt {
        background: none;
        color: white;
        border-radius: 0;
        border: 1px solid white;
        margin: 0 10px;
        height: 40px;
        padding: 0 15px;
        font-size: 1.1rem;
    }
</style>